
import type { WeeklyLeadersEmail } from '@whizz/api-model';
import type { PreviewData } from './modules/EmailPreview';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { repository } from '@whizz/api-client';
import { EmailConfigurationForm } from './modules/EmailConfigurationForm';
import EmailPreview from './modules/EmailPreview';
import { QUERIES_IDS } from '../../../util/vars';
import NoData from '../../../global/sections/NoData';
import { useI18n } from '@whizz/react-i18n';

const WeeklyLeadersEmailsPageComponent = () => {
  const { translate: t } = useI18n();
  const { schoolId } = useParams<{ schoolId: string }>();

  const getWeeklyLeadersEmails = useQuery({
    queryKey: [ QUERIES_IDS.ADMIN.GET_WEEKLY_LEADERS_EMAILS, schoolId ],
    queryFn: () => repository.AdminRepository.getSchoolWeeklyLeadersEmail(Number(schoolId)),
  });

  const state = getWeeklyLeadersEmails.isLoading ? 'loading' : (getWeeklyLeadersEmails.data ? 'loaded' : 'error');
  const weeklyLeadersEmail = getWeeklyLeadersEmails.data?.data ?? null;

  if (state === 'loading') {
    return <NoData noDataMessage={t('pages.ADMIN.LEADERS_EMAILS.LOADING')} />;
  }

  if (!weeklyLeadersEmail) {
    return null;
  }

  return <View weeklyLeadersEmail={weeklyLeadersEmail} />;
};

const View = ({ weeklyLeadersEmail }: { weeklyLeadersEmail: WeeklyLeadersEmail }) => {
  const [ previewData, setPreviewData ] = useState<PreviewData>({
    isEnabled: weeklyLeadersEmail.isEnabled ?? false,
    school: weeklyLeadersEmail.school,
    startDate: null,
    endDate: null,
    teachers: [],
    standardGreeting: true,
    message: null,
    reminderMessage: null,
    metricsComponents: [],
    studentsData: [],
  });

  return (
    <div className={'grid grid-cols-2 gap-10'}>
      <div>
        <EmailConfigurationForm
          weeklyLeadersEmail={weeklyLeadersEmail}
          setPreviewData={setPreviewData}
        />
      </div>
      <div>
        <EmailPreview
          previewData={previewData}
        />
      </div>
    </div>
  );
};

export { WeeklyLeadersEmailsPageComponent };

